import React from "react";
import PropTypes from "prop-types";

//
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

function CardInfo() {
  return (
    <div className="card-info">
      <Elements stripe={stripePromise}>
        <CheckoutForm />
      </Elements>
    </div>
  );
}

CardInfo.propTypes = {};

export default CardInfo;
